"use client";

import { useAnimate } from "framer-motion";
import type { ImageProps } from "next/image";
import Image from "next/image";

import { easeImageReveal } from "@/lib/animations";

export function FadeImage({ onLoad, priority, style, alt, ...props }: ImageProps) {
  const [scope, animate] = useAnimate<HTMLImageElement>();

  return (
    <Image
      ref={scope}
      {...props}
      alt={alt}
      priority={priority}
      style={{ ...style, opacity: priority ? 1 : 0 }}
      onLoad={(e) => {
        if (!priority) {
          animate(scope.current, { opacity: 1 }, easeImageReveal);
        }
        if (onLoad) onLoad(e);
      }}
    />
  );
}
